/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PayMateMetadataDto
 */
export interface PayMateMetadataDto {
    /**
     *
     * @type {string}
     * @memberof PayMateMetadataDto
     */
    metadata?: string;
}

/**
 * Check if a given object implements the PayMateMetadataDto interface.
 */
export function instanceOfPayMateMetadataDto(
    value: object,
): value is PayMateMetadataDto {
    return true;
}

export function PayMateMetadataDtoFromJSON(json: any): PayMateMetadataDto {
    return PayMateMetadataDtoFromJSONTyped(json, false);
}

export function PayMateMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PayMateMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        metadata: json["metadata"] == null ? undefined : json["metadata"],
    };
}

export function PayMateMetadataDtoToJSON(
    value?: PayMateMetadataDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        metadata: value["metadata"],
    };
}
